/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Misc/Placeholder': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M11.25 9h9.44c.14 0 .25-.11.25-.25v-.5c0-.14-.11-.25-.25-.25h-9.44c-.14 0-.25.11-.25.25v.5c0 .14.11.25.25.25m0 3h9.44c.14 0 .25-.11.25-.25v-.5c0-.14-.11-.25-.25-.25h-9.44c-.14 0-.25.11-.25.25v.5c0 .14.11.25.25.25m0 3h9.44c.14 0 .25-.11.25-.25v-.5c0-.14-.11-.25-.25-.25h-9.44c-.14 0-.25.11-.25.25v.5c0 .14.11.25.25.25m11.69 5c0 1.195-.345 3.425-.635 5H8.37c.27-1.53.57-3.57.57-5V6h14v14zm1.75-16H7.19c-.14 0-.25.11-.25.25V20c0 2-.71 5.655-.935 6.705A.246.246 0 0 0 6.25 27h17.495c.115 0 .215-.08.24-.195.195-.87.955-4.805.955-6.805V4.25c0-.14-.11-.25-.25-.25z"/>'
  }
})
